import React, { useState, useEffect } from "react";
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { DateRangeFilter } from "src/mtska-frontend-app-component/components/List/customSelectionFilter/dateRangeFilter/DateRangeFilter";
import { InputAutocomplete } from 'src/mtska-frontend-app-component';
import JSONPretty from 'react-json-pretty';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";

const Filters = ({ dataProviderName, filters:defaultFilters, style }) => {
    const { t } = useTranslation();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const { settingsLoaded, addFilter } = useSettingsContext(dataProviderName, defaultFilters)

    const [customDateRange, setCustomDateRange] = useState();
    const [areaName, setAreaName] = useState();
    const [shopName, setShopName] = useState();
    const [agentName, setAgentName] = useState();
    const [selectedValueAction, setSelectedValueAction] = useState();

    useEffect(() => {
        if (settingsLoaded == false) return;

        setCustomDateRange(filterModel?.items?.find(f => f.field === 'registered_at')?.value || null);
        setAreaName(filterModel?.items?.find(f => f.field === '_related_area_name')?.value || null);
        setShopName(filterModel?.items?.find(f => f.field === '_related_shop_name')?.value || null);
        setAgentName(filterModel?.items?.find(f => f.field === '_related_agent_fullname')?.value || null);

        setSelectedValueAction(filterModel?.items?.find(f => f.field === 'action')?.value || null);
    }, [filterModel])

    return (drawable &&
        <>
            {/* filterModel in Filters
            <JSONPretty data={filterModel} className="json-wrapper" style={{ overflow: 'scroll', fontSize: '10px' }}></JSONPretty> */}

            <Box className="dashboard-section-filters" sx={style}>
                <div>
                    <DateRangeFilter
                        applyValue={(updatedItem) => {
                            addFilter('registered_at', updatedItem.value, 'between')
                        }}
                        item={{
                            field: 'registered_at',
                            operator: 'between',
                            value: customDateRange,
                        }}
                        value={customDateRange}
                        mode="autocompleteInput"
                    />
                </div>

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="commercials/area/autocomplete"
                    label={t('area')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={areaName ? { "name": areaName } : null}
                    onChange={(v) => {
                        addFilter('_related_area_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />

                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="commercials/shop/autocomplete"
                    label={t('shop_name')}
                    searchkey={'name'}
                    labelkey={'name'}
                    project={['name']}
                    value={shopName ? { name: shopName } : null}

                    // per attivare questo filtro è necessario che Shop abbia le viste

                    // filters={areaName && {
                    //     items: [
                    //         {
                    //             field: '_related_area_name',
                    //             operator: 'equals',
                    //             value: areaName
                    //         }
                    //     ]
                    // }}

                    onChange={(v) => {
                        addFilter('_related_shop_name', v?.name);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />


                <InputAutocomplete
                    type="autocomplete"
                    dataProvider="persons/employment/autocomplete"
                    label={t('Agent')}
                    filters={{
                        items: [
                            {
                                field: "role",
                                operator: "equals",
                                value: "Agent"
                            },
                            {
                                field: "terminated_at_readable",
                                operator: "isEmpty",
                                value: "_"
                            },
                        ]
                    }}
                    searchkey={'_related_person_fullname'}
                    labelkey={'_related_person_fullname'}
                    project={['_related_person_fullname']}
                    value={agentName ? { _related_person_fullname: agentName } : null}
                    onChange={(v) => {
                        addFilter('_related_agent_fullname', v ? v?._related_person_fullname : null);
                    }}
                    style={{ flex: '1' }}
                    size={'small'}
                />

                <FormControl style={{ flex: '1' }} size="small">
                    <InputLabel
                        id="action-label"
                        sx={{
                            backgroundColor: 'white',
                            px: 0.5,
                        }}
                        shrink={selectedValueAction ? true : false}
                    >
                        {t("action")}
                    </InputLabel>
                    <Select
                        name="action"
                        value={selectedValueAction}
                        labelId="action-label"
                        onChange={(e) => {
                            setSelectedValueAction(e.target.value);
                            addFilter('action', e.target.value, 'equals');
                        }}
                    >
                        <MenuItem value="">{t("no choice")}</MenuItem>
                        <MenuItem value="charge">{t("charge")}</MenuItem>
                        <MenuItem value="charge_for_takeover">{t("charge_for_takeover")}</MenuItem>
                        <MenuItem value="discharge_acceptance">{t("discharge_acceptance")}</MenuItem>
                        <MenuItem value="discharge_end_of_agreement">{t("discharge_end_of_agreement")}</MenuItem>
                        <MenuItem value="discharge_area_change">{t("discharge_area_change")}</MenuItem>
                        <MenuItem value="start">{t("start")}</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </>
    )
}

export default Filters;